<template>
  <div v-if="gameStatus.pictureId">
    <v-card elevation="0">
      <v-img
          width="90vw"
          max-width="1000px"
          max-height="800px"
          elevation="7"
          contain
          :src="location()"
      >
        <v-btn
            color="red"
            elevation="2"
            fab
            absolute
            right
            v-on:click="dismiss"
            v-if="admin"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-img>
    </v-card>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'PicturePage',
  computed: mapGetters(['gameStatus', 'admin']),
  methods: {
    ...mapActions(['setPicture']),
    location() {
      return './pics/' + this.gameStatus.pictures[this.gameStatus.pictureId].source;
    },
    dismiss() {
      return this.setPicture(null);
    },
  },
}
</script>
